// src/components/modals/DetailsModal/WordModalTabs/ExamplesTabSkeleton.js
import React from 'react';
import SearchResultCardSkeleton from '../../../../search/skeletons/SearchResultCardSkeleton';

const ExamplesTabSkeleton = () => {
  return (
    <div className="relative p-6">
      {/* Background decor - same as ExamplesTab */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/5"
          style={{
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.07), rgba(236, 72, 153, 0.04))',
            width: '100px',
            height: '100px',
            top: '5%',
            right: '10%',
            boxShadow: '0 8px 32px rgba(59, 130, 246, 0.02)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
        </div>
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/5"
          style={{
            background: 'linear-gradient(45deg, rgba(236, 72, 153, 0.06), rgba(139, 92, 246, 0.03))',
            width: '70px',
            height: '70px',
            bottom: '15%',
            left: '8%',
            boxShadow: '0 8px 32px rgba(236, 72, 153, 0.01)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
        </div>
      </div>

      {/* Skeleton Content */}
      <div className="relative space-y-3">
        {Array.from({ length: 5 }).map((_, index) => (
          <SearchResultCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

export default ExamplesTabSkeleton;